import { makeStyles, Box, Typography, Button } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  content: {
    width: "100%",
    padding: "1rem",
    fontSize: "1rem",
    borderRadius: "10px 0 10px 10px",
    background: "#60a5fa20",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ".5rem"
  }
});
const InfoBox = ({ message, url }) => {
  const { content } = useStyles();
  return /* @__PURE__ */ React.createElement(Box, { className: content }, /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle1" }, " ", message, " "), url && /* @__PURE__ */ React.createElement(
    Button,
    {
      href: url,
      target: "_blank",
      style: { margin: "16px" },
      size: "large",
      variant: "outlined"
    },
    "See Docs"
  ));
};

export { InfoBox };
//# sourceMappingURL=InfoBox.esm.js.map
